/**
 * client/src/utils/manifeste-poste — Quel manifeste PWA annoncer selon la page.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Le portail ticket-plus affiche un QR code vers `https://<site>/counter` pour équiper un agent
 * sans rien télécharger : il ouvre le guichet, se connecte, puis « Installer l'application ».
 *
 * Mais le site n'annonçait qu'UN manifeste, `manifest.json`, dont `start_url` est la racine — qui
 * redirige vers `/distributor`. Le guichet installé depuis `/counter` se serait donc rouvert…
 * sur la borne de distribution.
 *
 * Sur les pages du guichet, on annonce `manifest-guichet.json` (start_url `/counter`, `id` propre :
 * le navigateur le traite comme une application distincte, installable à côté d'une autre).
 * Partout ailleurs, le manifeste d'origine, inchangé.
 *
 * Module PUR : testé directement par `apps/server/test-scripts`.
 */

export const MANIFESTE_DEFAUT = '/manifest.json';
export const MANIFESTE_GUICHET = '/manifest-guichet.json';

export function manifestePourChemin(pathname) {
  const p = String(pathname || '');
  return p === '/counter' || p.startsWith('/counter/') ? MANIFESTE_GUICHET : MANIFESTE_DEFAUT;
}
